import { AuthedRoutesEnum } from '@/core/enums';

export const isCustom = (value: string, defaultValue?: string) => {
  return !!value && !!defaultValue && value !== defaultValue;
};

export const COA_LINKS = [
  {
    label: 'Revenue Accounts Germany',
    to: AuthedRoutesEnum.COARevenue,
  },
  {
    label: 'Revenue Accounts Countries',
    to: AuthedRoutesEnum.COACountries,
  },
  {
    label: 'Debtor accounts',
    to: AuthedRoutesEnum.COADebtor,
  },
  {
    label: 'Movements of goods',
    to: AuthedRoutesEnum.COAShipments,
  },
];

export const OSS_ACCS_TYPES = ['oss_netto', 'oss_vat', 'rest'];

export const COUNTRY_ACCS_TYPES = [
  'vat_rate_high',
  'vat_rate_middle',
  'vat_rate_low',
  'vat_rate_low_second',
  'b2b_buyer_vat_number_not_null',
  'arrival_country_not_EU',
  'commingling_buy_taxable',
  'commingling_buy_tax_exempt',
];

export const REVENUE_ACCS_TYPES = [
  'vat_rate_high',
  'vat_rate_low',
  'rest',
  'b2b_buyer_vat_number_not_null',
  'arrival_country_not_EU',
  'commingling_buy_taxable',
];

export const SHIPMENTS_ACCS_TYPES = [
  'shipment_de_konto',
  'ship_to_de_gegenkonto',
  'shipment_ausgleich_de_konto',
  'ship_from_de_gegenkonto',
];
